(function (jQuery) {
    "use strict";

    var $ = jQuery;

    var _getAppsOnSrcPage = function (uri, src, content, successFn, failFn) {
        var myconfig = {
            targetUrl: InFlight.NLX.Cfg.Customer.psAuthBaseUrl() + uri,
            targetVerb: "GET",
            followProposedTemplate: false,
            showLoading: false,
            manualRequestObj: [
                { "Lbl": "menuItems", "Src": src, "Data": content, "Children": [] }
            ],
            callback: function (data) {
                if(data && data.ProposedTemplate.indexOf('login.aspx') !== -1){
                    failFn();
                    return;
                }

                if (!data || !data.CaptureResults || !data.CaptureResults.menuItems || !data.CaptureResults.menuItems.length) {
                    successFn([]);
                } else {
                    var keys = [];
                    $.each(data.CaptureResults.menuItems, function (i, element) {
                        keys.push(element.Properties.key);
                    });
                    successFn(keys);
                }
            }
        };

        InFlightDC.init(myconfig);
    };

    var _getAppsOnSrcPages = function (srcPages, fn) {
        var srcPageRequestsCompleted = 0;
        var enabledAppsOnSrcPages = [];

        var handleEnabledApps = function (keys) {
            srcPageRequestsCompleted++;
            //flatten the list for easier searching later
            $.merge(enabledAppsOnSrcPages, keys);

            if (srcPageRequestsCompleted === srcPages.length) {
                fn(enabledAppsOnSrcPages);
            }
        }
        
        // only look at the first src page to ensure the user is signed in before sending the remaining requests
        _getAppsOnSrcPage(srcPages[0].uri, srcPages[0].src, srcPages[0].content, function(keys){
            handleEnabledApps(keys);
            $.each(srcPages, function (i, srcPage) {
                if(i>0){
                    _getAppsOnSrcPage(srcPage.uri, srcPage.src, srcPage.content, handleEnabledApps, InFlight.User.doLogout);
                }
            });
        }, InFlight.User.doLogout);
    };

    var _isItemEnabledOnSrcPage = function (item, appsEnabledOnSrcPage) {
        for (var i = 0; i < appsEnabledOnSrcPage.length; i++) {
            if (item.key === null || item.key === undefined || appsEnabledOnSrcPage[i].indexOf(item.key) > -1) {
                if (item.urlCfg) {
                    var cfgUrl = InFlight.NLX.Cfg.Customer[item.urlCfg];
                    if (typeof cfgUrl === "function") {
                        item.url = cfgUrl();
                    } else {
                        return false;
                    }
                } else{
                    item.url = item.template;
                    item.delegateUrl = item.delegateTemplate;
                }               
                return true;
            }
        }
        return false;
    };

    var _getAppsThatAreEnabled = function (apps, appsEnabledOnSrcPage) {
        $.each(apps, function (i, app) {
            app.items = $.grep(app.items, function (item, i) {
                return _isItemEnabledOnSrcPage(item, appsEnabledOnSrcPage);
            });
        });

        apps = $.grep(apps, function (app, i) {
            return app.items && app.items.length > 0;
        });

        return apps;
    };

    var deferred = [];
    var sessionStorageKey = "__getAppsResult__";
   
    InFlight.User.getApps = function (_callback) {        
        var callback = function (result) {
            var tmp = deferred;
            deferred = [];
            $.each(tmp, function (i, fn) {
                fn(result);
            });
        };

        deferred.push(_callback);
        if (deferred.length > 1) {
            return;
        }

        if (!InFlight.User.isLoggedIn()) {
            console.log("not logged in");
            sessionStorage.removeItem(sessionStorageKey);
            callback(null);
            return;
        }

        var cachedResult = sessionStorage.getItem(sessionStorageKey);

        if (cachedResult) {
            var parsedResult = JSON.parse(cachedResult);
            console.log("getApps result from storage", parsedResult);
            callback(parsedResult);
            if (parsedResult.apps.length > 0) {
                return;
            }
        }

        $.getJSON(InFlight.NLX.Cfg.Customer.getAppsJson())
            .done(function (data) {
                var _resultHelper = function (result) {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(result));
                    callback(result);
                };

                if (!data.srcPages || !data.srcPages.length) {
                    console.log("no srcPages configuredin apps.json");
                    _resultHelper(data);
                    return;
                }

                _getAppsOnSrcPages(data.srcPages, function (appsEnabledOnSrcPages) {
                    var result = { "apps": _getAppsThatAreEnabled(data.apps, appsEnabledOnSrcPages) };
                    _resultHelper(result);
                });
            })
            .fail(function (data) {
                console.log("error", data);
                sessionStorage.removeItem(sessionStorageKey);
                callback(null);
            });
    };
})(jQuery);
